import type { MapMarkersWrapperProps } from "./map-markers.type";

import { useMap } from "@vis.gl/react-google-maps";

import MapMarkers from "./map-markers.component";

const MapMarkersWrapper = ({
  mapId,
  markers,
  noInfoWindow,
}: MapMarkersWrapperProps) => {
  const map = useMap();

  if (!map || !markers?.length) return null;

  return (
    <MapMarkers mapId={mapId} markers={markers} noInfoWindow={noInfoWindow} />
  );
};

export default MapMarkersWrapper;
